import { render, staticRenderFns } from "./StartQuizSmall.vue?vue&type=template&id=288ccfe5&scoped=true&functional=true"
var script = {}
import style0 from "./StartQuizSmall.vue?vue&type=style&index=0&id=288ccfe5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "288ccfe5",
  null
  
)

export default component.exports